<template>
  <div class="offers_page">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "ProductPromotionsHome",
};
</script>
